<div class="container" id="toolbar">

  <mat-button-toggle-group name="mapTool" (change)="toggleChange($event)"
    [hidden]="hiddenButton" multiple>
    <mat-button-toggle class="button-toogle" value="home" #home>
      <mat-icon>
        <span class="material-icons-outlined" [title]="translate('ir_casa')">home</span>
      </mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
  <button matBadgePosition="before" mat-raised-button
    [title]="translate('herramientas_cartografia')" (click)="onClickTools()">
    <mat-icon>
      <span class="material-icons-outlined">{{ selectedToolIcon || "construction" }}</span>
    </mat-icon>
  </button>
</div>
